export { default } from './LinkTicketsPrompt';
export * from './LinkTicketsPrompt';
